<template>
  <div class="header">
    <div class="box container">
      <div class="left">欢迎来到马士兵IT教育平台</div>
      <div class="right">
        <div class="email">邮箱：767169735@qq.com</div>
        <!-- <img
          src="../../../assets/wb.png"
          alt
          @mouseover="mouseover('wb')"
          @mouseleave="mouseleave"
        /> -->
        <img
          src="../../../assets/wx.png"
          alt
          @mouseover="mouseover('wx')"
          @mouseleave="mouseleave"
        />
        <div  @mouseover="mouseover('ph')"
              @mouseleave="mouseleave"
        style="cursor:pointer;"
        >
          <img
              src="../../../assets/iphone.png"
              alt

          />
          <span style="padding-left: 6px;"></span>App下载
        </div>

      </div>
      <div class="code" v-show="isshow">
        <img class="code__img" :src="imgSrc" alt />
        <div class="code__text">{{imgText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
let app = require('@/assets/down-app.png')
export default {
  name: 'Header',
  components: {},
  data () {
    return {
      isshow: false,
      imgSrc: '',
      imgText: '',
    }
  },
  methods: {
    // 移入
    mouseover (id) {
      const map = {
        wx: '//www.mashibing.com/img/wx.jpg',
        wxtext: '扫一扫 关注马士兵',
        phtext: '使用手机浏览器扫一扫 下载马士兵App',
        ph:app,
      }
      this.isshow = true
      this.imgSrc = map[id]
      this.imgText = map[id+'text']
    },
    // 移出
    mouseleave () {
      this.isshow = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/functions.scss';
@import '@/styles/common.scss';
.header {
  height: 45px;
  background: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  position: relative;
  .box {
    // width: 1200px;
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 100%;
    align-items: center;
    .right {
      display: flex;
      .email {
        margin-right: 14px;
      }
      img {
        height: 23px;
        width: 23px;
        margin-left: 11px;
        cursor: pointer;
      }
    }
  }
  .code {
    position: absolute;
    right: 0;
    z-index: 222;
    bottom: -170px;
    width: 153px;
    height: 168px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(235, 235, 235, 1);
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &__img {
      height: 104px;
      width: 103px;
      background: aqua;
    }
    &__text {
      font-size: 14px;
      color: #757575;
      margin-top: 14px;
    }
  }
}
</style>
